<h2 mat-dialog-title>Add Vendor Allocation</h2>
<mat-dialog-content style="padding-top: 16px; overflow: visible;">
  <form [formGroup]="form" style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Product Type</mat-label>
      <mat-select formControlName="productTypeId">
        <mat-option *ngFor="let pt of productTypes" [value]="pt.id">{{pt.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Vendor Name</mat-label>
      <input matInput formControlName="vendorName">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Amount</mat-label>
      <input matInput type="number" formControlName="amount">
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Currency</mat-label>
      <input matInput formControlName="currencyCode">
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Add</button>
</mat-dialog-actions>
